"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _flexSpot = _interopRequireDefault(require("@demant/react-bootstrap/lib/schemas/flex-spot"));

var _componentDataParser = _interopRequireDefault(require("@demant/react-bootstrap/lib/js/component-data-parser"));

var _pim = require("@demant/pim");

var _serviceNames = require("@demant/pim/lib/constants/service-names");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ComponentInstantiator = /*#__PURE__*/function () {
  function ComponentInstantiator() {
    _classCallCheck(this, ComponentInstantiator);

    this.component = null;
    this.settings = null;
    /**
     * @type {PIM}
     */

    this.pim = null;
  }

  _createClass(ComponentInstantiator, [{
    key: "init",
    value: function init() {
      this.settings = new _componentDataParser["default"](this.component, _flexSpot["default"]).getComponentData();
    }
  }, {
    key: "render",
    value: function render(renderMethod) {
      renderMethod({
        component: this.component,
        settings: this.settings,
        loadContent: this.loadContent.bind(this)
      });
    }
    /**
     * @param {Object} params
     * @param {string} params.Market
     * @param {number} params.ProductId
     * @param {number} params.DeviceId
     * @returns {Promise}
     */

  }, {
    key: "loadContent",
    value: function loadContent(params) {
      var _this = this;

      if (!this.pim) {
        return new Promise(function (_, reject) {
          reject(new Error('No pim instance set for ComponentInstantiator'));
        });
      }

      return new Promise(function (resolve) {
        _this.pim.getCatalogID(_serviceNames.SERVICE_NAMES.COMPATIBILITY_GUIDE).then(function () {
          return resolve(Promise.all([_this.pim.getCompatibilityGuideAccessories({
            Market: params.Market,
            ProductId: params.ProductId
          }), _this.pim.getCompatibilityGuideDevices(_objectSpread({
            ProductId: params.ProductId
          }, _this.pim.isPhoneArenaQuery && {
            IncludeExternalDevices: true
          })), _this.pim.getCompatibilityGuideProducts({
            Market: params.Market,
            DeviceId: params.DeviceId
          }), _this.pim.getCompatibilityGuideApps({
            ProductId: params.ProductId,
            DeviceId: params.DeviceId,
            Market: params.Market
          })]).then(function (results) {
            var _results$, _results$2, _results$3, _results$4, _results$5;

            return {
              accessories: ((_results$ = results[0]) === null || _results$ === void 0 ? void 0 : _results$.accessories) || results[0],
              devices: ((_results$2 = results[1]) === null || _results$2 === void 0 ? void 0 : _results$2.devices) || results[1],
              products: ((_results$3 = results[2]) === null || _results$3 === void 0 ? void 0 : _results$3.hearingAidSummaries) || ((_results$4 = results[2]) === null || _results$4 === void 0 ? void 0 : _results$4.hearingAid) || results[2],
              apps: ((_results$5 = results[3]) === null || _results$5 === void 0 ? void 0 : _results$5.apps) || results[3] || []
            };
          }));
        });
      });
    }
  }]);

  return ComponentInstantiator;
}();

var _default = ComponentInstantiator;
exports["default"] = _default;